// extracted by mini-css-extract-plugin
module.exports = {"social":"aa","socialLink":"ab","service":"ac"};